import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import ForkliftEstimatesWrapper from "@components/layouts/forkliftestimatesWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <ForkliftEstimatesWrapper>
            <TermsAndConditions
                category="Forklifts"
                domain="forkliftestimates.com"
            />
        </ForkliftEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
